<template>
  <div>
    <div class='messages-list-table'>
      <div class='message-container' v-for='message in group.Messages' :key='message.MessageId' v-if='!message.IsDeleted'>
        <message :message='message'/>
      </div>
    </div>
  </div>
</template>

<script>
  import Message from './Message/Message'

  export default {
    name: 'messageList',
    components: {
      Message,
    },
    props: [
        'group'
    ]
  }

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Messenger/MessageList/MessageList.vue